import { withRouter } from 'react-router-dom'
import CampaignIdMonitor from './CampaignIdMonitor'

export default withRouter(CampaignIdMonitor)
